<ion-card [ngClass]="this.color ? 'coins-green' : 'coins'">
  <ion-icon [src]="error? 'assets/SoccerCoinRed.svg'  :'assets/SoccerCoin.svg'" [color]="getColor()"></ion-icon>
  <ion-label [ngClass]="{'red': error}" [color]="getColor()">{{ price }}</ion-label>
</ion-card>
